import React from 'react';
import { NavBarTypes } from '../../../sections/sitewide';
import { desktopscreensize } from '../../../utilities/constants';

export const TickMark = () => {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ float: 'right', marginTop: '0.3rem' }}
    >
      <path
        d="M17.5 1.41L5.5 13.41L0 7.91L1.41 6.5L5.5 10.58L16.09 1.52588e-07L17.5 1.41Z"
        fill="#2ECC71"
      />
    </svg>
  );
};

export const TickMarkHelper = ({
  currentDetails,
  NavLinkText,
}: NavBarTypes.TTickMarkTypes) => {
  return currentDetails.activeComponent === NavLinkText &&
    currentDetails.widthwindow < desktopscreensize ? (
    <TickMark />
  ) : (
    <></>
  );
};
